"use client";

import React from "react";
import PropTypes from "prop-types";
import { X, Banknote } from "lucide-react";
import styles from "./css/unpaidOrderOptionsModal.module.css";

export default function UnpaidOrderOptionsModal({ isOpen, onRefund, onContinue, onClose }) {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.modal}>
        <button type="button" className={styles.closeButton} onClick={onClose} aria-label="Close">
          <X className={styles.closeIcon} />
        </button>

        <div className={styles.title}>Select an option:</div>

        <div className={styles.actionsRow}>
          <button type="button" className={`${styles.button} ${styles.refundButton}`} onClick={onRefund}>
            <Banknote className={styles.buttonIcon} />
            <span>Refund</span>
          </button>

          <button type="button" className={`${styles.button} ${styles.continueButton}`} onClick={onContinue}>
            <span>Continue to payment</span>
          </button>
        </div>
      </div>
    </div>
  );
}

UnpaidOrderOptionsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRefund: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
